import { useEffect, useRef, type ReactNode } from 'react'
import { useQueryClient } from '@tanstack/react-query'

import { useMiniAppQueryScope } from '@/lib/query-scope'

export function MiniAppSessionBoundary({ children }: { children: ReactNode }) {
  const queryClient = useQueryClient()
  const scope = useMiniAppQueryScope()
  const previousScope = useRef(scope)

  useEffect(() => {
    if (previousScope.current === scope) return
    previousScope.current = scope
    void queryClient.cancelQueries().then(() => queryClient.clear())
  }, [queryClient, scope])

  return children
}
